module.exports = __webpack_public_path__ + "img/strap width.85a8c2da.png";